export default __webpack_public_path__ + "static/email-23e06f016ec25420c539063d2bec6c00.jpg";